import React, { useState } from 'react';
import { Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import CloseMatch from './components/CloseMatch';
import Encounters from './components/Encounters';
import FaxDetails from './components/FaxDetails';
import HistoricalClaims from './components/HistoricalClaims';
import RefferralFile from './components/RefferralFile';
import ErrorBoundary from 'components/ErrorBoundary';

const ClaimsDetailTab = (props) => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const hasHistoricalClaims = activeTab === '1';
  const hasCloseMatch = activeTab === '2';
  const hasFixDetails = activeTab === '3';
  const hasEncounters = activeTab === '4';
  const hasReferral = activeTab === '5';

  return (
    <div>
      <Nav tabs className='border-0 px-3 py-0'>
        <NavItem>
          <NavLink
            className={classNames({
              activeState: activeTab === '1',
            })}
            onClick={() => {
              toggle('1');
            }}
          >
            Historical Claims
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classNames({
              activeState: activeTab === '2',
            })}
            onClick={() => {
              toggle('2');
            }}
          >
            Close Match
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classNames({
              activeState: activeTab === '3',
            })}
            onClick={() => {
              toggle('3');
            }}
          >
            Fax Details
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classNames({
              activeState: activeTab === '4',
            })}
            onClick={() => {
              toggle('4');
            }}
          >
            Encounters
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classNames({
              activeState: activeTab === '5',
            })}
            onClick={() => {
              toggle('5');
            }}
          >
            Referrals
          </NavLink>
        </NavItem>
      </Nav>
      <hr className='mb-0 mt-2' />
      <TabContent activeTab={activeTab} className='px-3 mt-0 pt-0'>
        <TabPane tabId='1'>
          {hasHistoricalClaims && (
            <ErrorBoundary>
              <HistoricalClaims {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='2'>
          {hasCloseMatch && (
            <ErrorBoundary>
              <CloseMatch {...props} />
            </ErrorBoundary>
          )}
        </TabPane>

        <TabPane tabId='3'>
          {hasFixDetails && (
            <ErrorBoundary>
              <FaxDetails {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='4'>
          {hasEncounters && (
            <ErrorBoundary>
              <Encounters {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId='5'>
          {hasReferral && (
            <ErrorBoundary>
              <RefferralFile {...props} />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default ClaimsDetailTab;
